import CustomButton from '@components/Button/Button';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Radio from '@mui/material/Radio';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { Divider } from '@mui/material';
import Image from 'next/image';
import { assignRole } from '@redux/services/teams';
import { useSelector, useDispatch } from 'react-redux';
import { setCustomAlert } from '@redux/actions/general';

export default function AssignRole({
  memberInfo,
  setMemberInfo,
  setHelperState,
  helperState,
}) {
  const { selectedAvatarOption } = useSelector((state) => state?.user);
  const [loading, setLoading] = useState(false);
  const [roleAssigned, setRoleAssigned] = useState(false);
  const [memberRole, setMemberRole] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setMemberRole(memberInfo?.role);
  }, []);

  const handleRoleAssign = () => {
    setLoading(true);
    assignRole(
      { role: memberInfo?.role },
      selectedAvatarOption?._id,
      memberInfo?.id
    )
      .then(() => {
        setHelperState({ ...helperState });
        setRoleAssigned(true);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        dispatch(
          setCustomAlert({
            message: 'Something went wrong! TRY AGAIN',
            state: true,
            type: 'error',
          })
        );
      });
  };
  const handleChange = (e) => {
    setMemberInfo({ ...memberInfo, role: e.target.value });
  };
  return (
    <div className='text-custom-font-color dark:text-white'>
      {!roleAssigned ? (
        <div>
          <div className='text-sm '>
            Assign a role to <b className='capitalize'>{memberInfo?.name}</b>.
          </div>
          <div className='pt-3 flex items-center'>
            <Radio
              sx={{ padding: '0px' }}
              name='role'
              value='member'
              checked={memberInfo?.role === 'member'}
              onChange={handleChange}
            />
            <div className='text-sm pl-2'>Member (Default)</div>
          </div>
          <div className=' flex items-center pt-3'>
            <Radio
              sx={{ padding: '0px' }}
              name='role'
              value='administrator'
              checked={memberInfo?.role === 'administrator'}
              onChange={handleChange}
            />
            <div className='text-sm pl-2'>Administrator</div>
          </div>
          {memberInfo?.role === 'administrator' ? (
            <>
              <div className='pt-3 pb-4 flex'>
                <AnnouncementIcon className='pr-1' />
                <div className='text-xs pl-1'>
                  By assigning an admin role to your team member, you're
                  granting them permission to manage your team.
                </div>
              </div>
              <Divider />
            </>
          ) : null}
          <div className='pt-4 pb-3'>
            <CustomButton
              btnColor='blue'
              disabled={memberRole === memberInfo?.role}
              fullWidth
              loading={loading}
              onClick={handleRoleAssign}
            >
              Confirm
            </CustomButton>
          </div>
        </div>
      ) : (
        <div className='text-center'>
          <div className='flex justify-center'>
            <Image
              src='/assets/success.svg'
              alt='success'
              width={96}
              height={96}
            />
          </div>
          <div className='font-bold pt-4 text-[20px]'>Success!</div>
          <div className='py-3'>
            You’ve successfully assigned{' '}
            <b className='capitalize'>{memberInfo?.name}</b> the role
            <b className='capitalize'> {memberInfo?.role}</b>.
            {memberInfo?.role === 'member' ? null : (
              <span>They will now be able to manage your team.</span>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
AssignRole.propTypes = {
  memberInfo: PropTypes.object,
  setMemberInfo: PropTypes.func,
  setHelperState: PropTypes.func,
  helperState: PropTypes.object,
};
